export const SELECTED_TEMPLATE = "SELECTED_TEMPLATE";
